import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core/styles";
import * as React from "react";
import FormButton from "../../../../../components/FormButton/FormButton";
import TextArea from "../../../../../components/TextArea/TextArea";
import Icon from "../../../../../components/Icon/Icon";

const TERMS_AND_CONDITIONS = "This Commercial Loan Agreement (\"Agreement\") is made by and between Salaryo Inc. (the “Company”, \"we,\" \"us,\" \"our\" or \"Salaryo\") and merchant (\"you\" or \"Merchant\"), along with the owner, principal shareholder, member or other owner or executive of Merchant who submitted this Application on behalf of Merchant (\"Owner\"), as of the date specified above. You agree to borrow, and we agree to lend to you, the amount specified above. You promise to repay this Loan, the Amount and the Monthly Fees as defined above, plus all other amounts that may become due under this Agreement, according to the payment schedule in the Annex. \n" +
    "Commercial Loan Merchant and Owner each understand, acknowledge and agree that Merchant and Owner (a) are entering into this Agreement as a commercial purpose transaction , (b) will not use any portion of any credit extended for personal, family or household purposes, and (c) will not repay Salaryo from any consumer account. This means that certain important duties imposed upon transactions and communications for consumer purposes, and certain important rights conferred upon consumers, pursuant to federal or state law, will not apply to this Agreement or any aspect of the transactions executed thereof. Merchant and Owner also understand, acknowledge and agree that Salaryo may be unable to confirm whether, for example, any particular use of any amount loaned or any particular payment conforms to this section. Merchant and Owner understand, acknowledge and agree that a breach by Merchant of the provisions of this section will not affect our right to (a) enforce this Agreement, regardless of the purpose for which any amount loaned is in fact used, or (b) use any remedy legally available to us in a commercial transaction, even if that remedy would not have been available had any amount loaned been disbursed for consumer purposes or payment delivered from a consumer account \n" +
    "Amount The Loan amount in United States Dollars, as specified above. \n" +
    "Duration This Loan has a fixed duration of 6 (six), 12 (twelve) or 18 (eighteen) months. A repayment schedule, as described in the Repayment Schedule Annex. For Office Security Deposit financing transactions, the duration will be the earlier of (a) 12 (twelve) months from the date of transfer of funds or (b) the date upon which the Security Deposit is returned in full to Salaryo. This duration is renewable at Salaryo’s discretion. \n" +
    "Monthly Fee We will charge you with interest (“Monthly Fee” or “Subscription”) for each month of the Duration in which the Amount, or any portion of the Amount, remains outstanding. \n" +
    "Principal Amount We will charge you with the Principal Amount for each month for the Duration of this Loan as specified in the Annex. For Office Security Deposit financing transactions, the full Principal Amount will be charged in a single installment after 12 months. \n"

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    header: {
        fontSize: 20,
        fontWeight: 600,
        color: "#305cc6",
        marginBottom: "1em",
        display: "flex"
    },
    subHeader: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#3d3e43",
        marginBottom: "1em",
        display: "flex",
        marginLeft: ".4em"
    },
    textAreaContainer: {
        marginBottom: "1em"
    },
    spaceLeft: {
        marginLeft: ".5em"
    },
    connector: {
        border: "1px solid #305cc6",
        position: "absolute",
        top: "50%",
        left: "3%",
        height: "2em"
    },
    headerContainer: {
        position: "relative"
    },
    navigationContainer: {
        display: "flex",
        justifyContent: "space-around"
    },
    buttonContainer: {
        width: "10em"
    },
    back: {
        fontSize: 14,
        fontWeight: 500,
        color: "#9ca6ad",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        margin: "auto 0"
    }

});

@(withStyles(styles) as any)
export default class FormTermsAndConditions extends React.Component<
    Partial<WithStyles<any>>
    > {

    public render() {
        const {classes} = this.props;
        return (
            <>
                {this.renderHeader()}
                {this.renderSubHeader()}
                <div className={classes!.textAreaContainer}><TextArea text={TERMS_AND_CONDITIONS}/></div>
                {this.renderNavigation()}
            </>
        );
    }
    private navigateForward = () => {
        console.log("forward");
    };

    private navigateBack = () => {
        console.log("back")
    };

    private renderHeader = () => {
        const {classes} = this.props;
        return (
            <div className={classes!.headerContainer}>
                <div className={classes!.header}>
                    <Icon icon={'stepBigFull'}/>
                    <div className={classes!.spaceLeft}>Commercial Loan Agreement</div>
                </div>
                <div className={classes!.connector}/>
            </div>
        )
    };

    private renderSubHeader = () => {
        const {classes} = this.props;
        return (
            <div className={classes!.subHeader}>
                <Icon icon={"stepSmallFull"} />
                <div className={classes!.spaceLeft}>Terms and Conditions</div>
            </div>
        )
    }

    private renderNavigation = () => {
        const {classes} = this.props;
        return(
            <div className={classes!.navigationContainer}>
                <div className={classes!.back} onClick={this.navigateBack}>Back</div>
                <div className={classes!.buttonContainer}> <FormButton click={this.navigateForward} btnText={'I Agree'} classes={"yellow"}/></div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormT&C/FormT&C.tsx